export const en = {
  btnTextChangePassword: 'Change Password',
  formChangePassword: {
    btnTextSubmit: 'Save',
    labelCurrentPassword: 'Current Password',
    labelNewPassword: 'New Password',
    labelPasswordConfirmation: 'Retype New Password',
  },
  headerAccountPreferences: 'Account Preferences',
  labelMyNumberOfNetworks: 'My Number Of Networks',
  linkedNetworks: {
    default: 'Default Network',
    expired: 'Expired',
    header: 'Linked Networks',
    labelTitle: 'Set as Default Network',
  },
  maskPassword: '************',
  sections: {
    headerEmailAddresses: 'Email Addresses',
    headerLoginInformation: 'Login Information',
    headerPersonalInformation: 'Personal Information',
    headerConsentPreferences: 'Microsoft Clarity Consent',
    headerEmailPreferences: 'Email Preferences',
  },
  consentPreferences: {
    microsoftClarityLabel: 'Microsoft Clarity Consent',
    microsoftClarityDescription:
      "Allow cookie for Microsoft Clarity to help us understand how people use our site so we can improve everyone's experience. All data from Clarity is anonymized.",
  },
  emailPreferences: {
    categories: {
      using_simpli5: 'Using Simpli5',
      transactional: 'Transactional',
      marketing: 'Marketing',
    },
    descriptions: {
      using_simpli5: 'Activation emails, onboarding tips, SenSai coaching insights, and platform updates.',
      transactional: 'Receipts, security alerts, and account notifications. Required — cannot be disabled.',
      marketing: 'Promotions, events, and Simpli5 news.',
    },
    lockedTooltip: 'Required for account security and receipts — cannot be disabled.',
    unsubscribeAllButton: 'Unsubscribe from all',
    confirmTitle: 'Unsubscribe from all emails?',
    confirmMessage:
      'You will be opted out of all non-transactional email categories. You can re-enable them at any time from this page.',
  },
}

export const es = en
